module.exports = __webpack_public_path__ + "assets/normal/images/reward_crown.eb09164d.png";